import React from 'react';
import { Link } from 'react-router-dom';
import { siteConfig } from '../../data/mock';

const Hero = () => {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-light text-gray-900 leading-tight" style={{ fontFamily: 'Georgia, serif' }}>
          Originals Paintings and Fine Art Prints
        </h1>
        <p className="mt-6 text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
          {siteConfig.description}
        </p>
        <Link
          to="/collections"
          className="inline-block mt-8 px-8 py-4 bg-black text-white text-sm tracking-wide hover:bg-gray-800 transition-colors rounded-md"
        >
          Check out my collections
        </Link>
      </div>
    </section>
  );
};

export default Hero;
